/**
 * Group Now timeline entries by month/year.
 * Inserts month separators in reverse-chronological feed.
 */
export default function nowTimeline() {
    const timeline = document.querySelector('.gh-now-timeline');
    if (!timeline) return;

    const items = timeline.querySelectorAll('.gh-now-item');
    if (!items.length) return;

    const isFr = document.documentElement.getAttribute('data-lang') === 'fr';
    const formatter = new Intl.DateTimeFormat(isFr ? 'fr-FR' : 'en-US', {
        month: 'long',
        year: 'numeric'
    });

    let previousKey = '';

    for (let i = 0; i < items.length; i++) {
        const item = items[i];
        const dateEl = item.querySelector('.gh-now-date[datetime]');
        if (!dateEl) continue;

        const raw = dateEl.getAttribute('datetime') || '';
        const parts = raw.split('-');
        if (parts.length < 2) continue;

        const year = Number(parts[0]);
        const month = Number(parts[1]);
        if (!year || !month) continue;

        const key = String(year) + '-' + String(month).padStart(2, '0');

        if (key !== previousKey) {
            const monthRow = document.createElement('li');
            monthRow.className = 'gh-now-month';

            const label = document.createElement('span');
            label.className = 'gh-now-month-label';
            label.textContent = formatter.format(new Date(year, month - 1, 1));

            monthRow.appendChild(label);
            timeline.insertBefore(monthRow, item);
            previousKey = key;
        }
    }
}
